export default "__VITE_ASSET__CQDCtqNL__"